
export default
	name: "empty"
